import { useEffect, useRef, useState } from "react";
import { register, call, remove } from "../funcStore";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import VTuberProfile from "../components/vtuber/VTuberProfile";
import StreamTrends from "../components/trends/StreamTrends";
import { searchVtuberById } from "../api/commonApi";
import VTuberVideoList from "../components/vtuber/VTuberVideoList";
import { sortAttribute } from "../utils/attributes";

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  linkButton: {
    border: "none",
    background: "none",
    padding: 0,
    color: "#4b3f8f",
    font: "inherit",
    textDecoration: "underline",
    cursor: "pointer",
  },
  detailMain: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "24px",
    maxWidth: "720px",
    margin: "0 auto",
  },
};

function VTuberDetailPage() {
  // state
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_LOADING = "loading";
  const STATE_LOADED = "loaded";
  const STATE_NOT_FOUND = "notFound";
  const [state, setState] = useState(STATE_BEFORE_INIT);

  // is_visiable が true でも is_arrow が false の間は
  // タグとヒートマップを出さない
  const [contentHidden, setContentHidden] = useState(false);

  const contentHiddenRef = useRef(contentHidden);
  contentHiddenRef.current = contentHidden;

  //data
  const dataRef = useRef({
    vtuberId: call("app.getSelectedVtuberId"),
    vtuber: null,
    clickedTag: "",
  });

  const init = () => {
    register("vtuberDetailPage.load", async (id) => {
      setState(STATE_LOADING);

      console.log(id)
      const vtuber = await searchVtuberById(id);
      dataRef.current.vtuber = sortAttribute(vtuber);

      setContentHidden(
        Boolean(vtuber?.is_visiable) && !Boolean(vtuber?.is_arrow),
      );

      setState(vtuber ? STATE_LOADED : STATE_NOT_FOUND);
    });

    register("vtuberDetailPage.setContentHidden", (hidden) => {
      setContentHidden(Boolean(hidden));
    });

    register("vtuberDetailPage.getContentHidden", () => contentHiddenRef.current);

    call("vtuberDetailPage.load", dataRef.current.vtuberId);

    register("vtuberDetailPage.getVtuber", () => dataRef.current.vtuber);
  };

  // effect
  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
  }, [state]);

  useEffect(() => {
    return () => {
      remove("vtuberDetailPage.load");
      remove("vtuberDetailPage.getVtuber");
      remove("vtuberDetailPage.setContentHidden");
      remove("vtuberDetailPage.getContentHidden");
    };
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  const vtuber = dataRef.current.vtuber;

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.detailMain}>
        {state === STATE_LOADING && <p>読み込み中...</p>}

        {state === STATE_NOT_FOUND && (
          <p>
            VTuberが見つかりませんでした。
            <button
              type="button"
              style={styles.linkButton}
              onClick={() => call("app.navigateToSearch")}
            >
              検索に戻る
            </button>
          </p>
        )}

        {state === STATE_LOADED && vtuber && (
          <>
            <VTuberProfile vtuber={vtuber} />

            {!contentHidden && <StreamTrends vtuber={vtuber} />}

            <VTuberVideoList vtuberId={vtuber.id} />
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default VTuberDetailPage;
